import React from 'react';
import { H2, P, OL, LI, Code, Pre, Callout, FeatureLink } from './_shared';

export default {
  slug: 'api-keys',
  title: 'Creating & using API keys',
  category: 'integrations',
  summary: 'Authenticate the public API with rf_live_ keys. 600 req / 5 min per key.',
  searchTerms: ['api', 'key', 'token', 'authentication', 'bearer', 'rate limit'],
  related: ['public-api', 'webhooks'],
  Body: () => (
    <>
      <H2>Creating a key</H2>
      <OL>
        <LI>Go to <FeatureLink to="/settings/integrations">Integrations → API Keys</FeatureLink>.</LI>
        <LI>Click "New API Key," give it a description (which integration or script will use it).</LI>
        <LI>The plaintext key is shown <strong>once</strong> — copy it into your password manager or .env file immediately. We store only the SHA-256 hash.</LI>
      </OL>

      <H2>Using a key</H2>
      <P>Pass it via either header:</P>
      <Pre>{`Authorization: Bearer rf_live_xxxxxxxxxxxxxxxx
# or
X-API-Key: rf_live_xxxxxxxxxxxxxxxx`}</Pre>

      <H2>Rate limits</H2>
      <P>
        600 requests per 5 minutes per key. Responses include{' '}
        <Code>X-RateLimit-Remaining</Code> and <Code>X-RateLimit-Reset</Code>.
        Exceeding the limit returns 429 with a <Code>Retry-After</Code> header.
      </P>

      <Callout kind="warn">
        Don't ship keys in mobile-app or browser-side code. The public API
        is server-to-server. If you need browser integration, build a thin
        proxy on your own server.
      </Callout>

      <H2>Revoking</H2>
      <P>
        Same screen — click the trash icon. Revocation takes effect within
        60 seconds. Requests with a revoked key get 401.
      </P>
    </>
  ),
};
